import { Grid, Typography } from '@mui/material'
import { useAppDispatch } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import PrimaryCard from 'components/PrimaryCard'
import { ReactElement, useEffect } from 'react'

export default function Home(): ReactElement {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(UIAction.setBreadcrumbs([]))
  }, [dispatch])
  return (
    <Grid container spacing={2} mt={4}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ borderBottom: 2 }}
          fontWeight="bold"
        >
          ホーム
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <PrimaryCard
          to="/event"
          title="イベント管理"
          body={
            <p>
              各団体が本アプリを利用して作成したイベント情報を確認できます。
              また、開催されたイベントについては、イベント参加者の統計情報を確認できます。
            </p>
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PrimaryCard
          to="/quiz"
          title="問題テンプレート管理"
          body={
            <p>
              各団体に提供にする謎解き問題のテンプレートを確認できます。
              また、新規の問題テンプレートを作成できます。
            </p>
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PrimaryCard
          to="/organizer"
          title="団体情報"
          body={
            <p>
              団体名、担当者名等の登録情報が確認できます。
              また、ログイン情報を除く登録情報が変更できます。
            </p>
          }
        />
      </Grid>
    </Grid>
  )
}
